/** @file puppet.setFacing: changes the body facing steps per turn and the turn rate. */
import { checkNumber } from '@zilo/pose3d-format/validate/fields/checkNumber';
import type { CommandDef } from '../apply/commandDef';
import { compact } from '../validate/compact';
import { readFacingSteps } from '../validate/readFacingSteps';
import { readInput } from '../validate/readInput';

const positive = checkNumber({ above: 0 });

/** `puppet.setFacing { steps?, turnRate? }` → `{ facing }`; steps 1-360 or `free`; inverse: both previous values. */
export const puppetSetFacingCommand: CommandDef<'puppet.setFacing'> = {
  name: 'puppet.setFacing',
  /** Checks the raw input (VALIDATION under the input path). */
  validate: (input, path) => {
    const r = readInput(input, path, ['steps', 'turnRate']);
    return compact({
      steps: r.opt('steps', (k) => readFacingSteps(r.raw(k), r.at(k))),
      turnRate: r.opt('turnRate', (k) => {
        positive(r.raw(k), r.at(k));
        return r.raw(k) as number;
      }),
    });
  },
  /** Applies the command to the draft and returns its result and inverse. */
  apply: (draft, input) => {
    const prev = { ...draft.puppet.facing };
    draft.puppet.facing = { steps: input.steps ?? prev.steps, turnRate: input.turnRate ?? prev.turnRate };
    return { result: { facing: { ...draft.puppet.facing } }, warnings: [], inverse: [{ name: 'puppet.setFacing', input: prev }] };
  },
};
